// Indicador visual "digitando..." enquanto o personagem processa a resposta
import React from 'react';
import { Bubble, Dot } from './styled';

/**
 * @param {{ characterName?: string }} props - Nome do personagem (opcional)
 */
const TypingIndicator = ({ characterName }) => {
    return (
        <Bubble role="status" aria-live="polite" aria-label={`${characterName || 'O personagem'} está digitando`}>
            {characterName && <strong>{characterName}</strong>}
            <Dot delay="0s" />
            <Dot delay="0.2s" />
            <Dot delay="0.4s" />
        </Bubble>
    );
};

export default TypingIndicator;
